import { Tag, Typography, Space } from "antd";

const {Text} = Typography;
const columns = [
  {
    title: "تاریخ ثبت نام",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 160,
    sorter: true,
    ellipsis: true
  },
  {
    title: "نام",
    dataIndex: "name",
    key: "name",
    width: 160,
    sorter: true,
    ellipsis: true
  },
  {
    title: "کدملی",
    dataIndex: "nationalIdCardNo",
    key: "nationalIdCardNo",
    width: 125,
  },
  {
    title: "موبایل",
    dataIndex: "mobile",
    key: "mobile",
    width: 125,
  },
  {
    title: "سطح",
    dataIndex: "userRole",
    key: "userRole",
    width: 80,
    sorter: true,
    render: (_, { userRole }) => (
      <>
        {userRole?.map((role) => {
          return (
            <Text mark={role === "ADMIN"} key={role}>
              {role === "ADMIN" ? "مدیر" : "کاربر"}
            </Text>
          );
        })}
      </>
    ),
  },

  {
    title: "وضعیت",
    dataIndex: "confirmStatus",
    key: "confirmStatus",
    width: 110,
    sorter: true,
    render: (_, { confirmStatus }) => (
      <>
        {confirmStatus?.map((status) => {
          const color =
            status === "SUCCESS"
              ? "green"
              : status === "ERROR"
              ? "red"
              : status === "PENDING" ? "orange" : "blue";
          return (
            <Tag color={color} key={status}>
              { status === "SUCCESS"
              ? "تایید شده"
              : status === "ERROR"
              ? "رد شده"
              : status === "PENDING" ? "در انتظار" : "ثبت نشده"}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
  },
];

export default columns;
